<template>
  <div class="shipment">
    <h4>Shipping details:</h4>
    <div class="shipment-details">
      <div>
        <span class="label">Ship to:</span> {{ zip }}
      </div>
      <div>
        <span class="label">Pieces:</span> {{ pieces }}
      </div>
      <div>
        <span class="label">Weight:</span> {{ weight }} lbs
      </div>
      <div>
        <span class="label">Value:</span> {{ value | formattedPrice(currency) }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.shipment{
  display: flex;
  flex-direction: column;
  align-items: center;
}

.shipment-details div {
  min-width: 150px;
}

.shipment-details {
  column-count: 2;
}

@media (min-width: 1024px){
  .shipment{
    flex-direction: row;
  }

  .shipment-details {
    column-count: 4;
    margin-left: auto;
  }
}

.label {
  font-weight: 700;
  font-size: 18px;
  line-height: 175%;
  color: #262626;
}
</style>

<script>
export default {
  components: {},
  props: {
    zip: String,
    pieces: Number,
    weight: Number,
    value: Number,
    currency: String,
  },
  data: () => ({}),
}
</script>
